
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 24c3.869 0 7-3.131 7-7s-3.131-7-7-7-7 3.131-7 7 3.131 7 7 7zm4.8 2h-.519c-1.3.625-2.743 1-4.281 1-1.537 0-2.975-.375-4.281-1H11.2A7.202 7.202 0 004 33.2V35a3 3 0 003 3h18a3 3 0 003-3v-1.8c0-3.975-3.225-7.2-7.2-7.2zM34 24c3.313 0 6-2.688 6-6 0-3.313-2.688-6-6-6-3.313 0-6 2.688-6 6 0 3.313 2.688 6 6 6zm3 2h-.237c-.87.3-1.788.5-2.763.5-.975 0-1.894-.2-2.762-.5H31c-1.275 0-2.45.369-3.481.962C29.044 28.606 30 30.788 30 33.2v2.4c0 .137-.031.269-.038.4H41a3 3 0 003-3c0-3.869-3.131-7-7-7z","fill":"#535353"}})])
          )
        }
      }
    